import React, { useContext, useState } from 'react';
import { CartContext } from '../App';
import './ProductCard.css';

export default function ProductCard({ product }) {
  const { addToCart } = useContext(CartContext);
  const [added, setAdded] = useState(false);
  const [wishlist, setWishlist] = useState(false);

  const discount = Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100);

  const handleAdd = () => {
    addToCart(product);
    setAdded(true);
    setTimeout(() => setAdded(false), 1800);
  };

  return (
    <div className="product-card">
      <div className="card-image-wrap">
        <img src={product.image} alt={product.name} loading="lazy" />
        <div className="card-overlay">
          <button className="btn-add-to-bag" onClick={handleAdd}>
            {added ? '✓ Added' : 'Add to Bag'}
          </button>
        </div>
        {product.tag && <span className="product-tag">{product.tag}</span>}
        <button
          className={`wishlist-btn ${wishlist ? 'active' : ''}`}
          onClick={() => setWishlist(w => !w)}
          aria-label="wishlist"
        >
          {wishlist ? '♥' : '♡'}
        </button>
        <div className="discount-badge">-{discount}%</div>
      </div>

      <div className="card-body">
        <p className="card-category">{product.category}</p>
        <h3 className="card-name">{product.name}</h3>
        <p className="card-desc">{product.description}</p>

        <div className="card-colors">
          {product.colors.map((c, i) => (
            <span key={i} className="color-dot" style={{ background: c }} />
          ))}
        </div>

        <div className="card-price-row">
          <span className="price-current">₹{product.price.toLocaleString()}</span>
          <span className="price-original">₹{product.originalPrice.toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
}
